import { Observable } from 'rxjs';
import { AssetAttribute, AssetsApi, Attribute, PagedAssetResponse } from 'src/app/hickory-api';
import { mockHandler } from '../mock.handler';
import { getPage } from './data/PageHelper';

export class MockAssetsApi extends AssetsApi {

  getAssetsAttributesValues(id: string, page?: number, pageSize?: number, search?: string, assetIds?: Array<string>)
    : Observable<any> {
    let values: string[] = [];
    switch (id) {
      case '09eda1084182443eb70b0d0757746fa8':
        values = [
          'Europe',
          'MEA',
          'North America',
          'LATAM',
          'APAC'
        ];
        break;
      case '05f06f598b9e471db95849f4abd8b8bd':
        values = [
          'AlertSense'
        ];
        break;
      case 'd9447c5505c74194b9fecb4a17c03f30':
        values = [
          'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU',
          'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN',
          'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK',
          'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA',
          'WV', 'WI', 'WY'
        ];
        break;
    }
    if (search) {
      values = values.filter(i => i.toLowerCase().indexOf(search.toLowerCase()) >= 0);
    }
    return mockHandler(getPage(values, page, pageSize));
  }

  findAssets(page?: number, pageSize?: number, assetIds?: Array<string>, attributeIds?: Array<string>, attributeName?: string, attributeValue?: string): Observable<any> {
    return mockHandler({
      totalItemCount: 1,
      pageCount: 1,
      page: 1,
      pageSize: 25,
      items: [
        {
          id: '1e92a37e1e3a11e793ae92361f002671',
          externalId: '0',
          attributes: [
            {
              id: '45aef5b6bacb4dd1b8a64699787a6297',
              name: 'FacilityLocation',
              type: Attribute.TypeEnum.Point,
              value: '43.6610;-116.3374'
            },
            {
              id: '05f06f598b9e471db95849f4abd8b8bd',
              name: 'FacilityName',
              type: Attribute.TypeEnum.Open,
              value: 'AlertSense'
            },
            {
              id: 'd9447c5505c74194b9fecb4a17c03f30',
              name: 'LocationType',
              type: Attribute.TypeEnum.Set,
              value: 'Franchised'
            }
          ]
        }
      ],
      'hasErrors': false,
      'isValid': true
    } as PagedAssetResponse);
  }

  getAssetsAttributes(page?: number, pageSize?: number): Observable<any> {
    return mockHandler({
      totalItemCount: 16,
      pageCount: 1,
      page: 1,
      pageSize: 25,
      items: [
        {
          id: '09eda1084182443eb70b0d0757746fa8',
          name: 'Area',
          type: AssetAttribute.TypeEnum.Set
        },
        {
          id: '23f36832a58041d3873f24311a56fd48',
          name: 'FacilityCity',
          type: AssetAttribute.TypeEnum.Open
        },
        {
          id: 'f396d32cb1854e5194a524c50bf72ecf',
          name: 'FacilityAddress2',
          type: AssetAttribute.TypeEnum.Open
        },
        {
          id: '54bf0ae55db7498b918827bf4ba50fe9',
          name: 'Brand',
          type: AssetAttribute.TypeEnum.Set
        },
        {
          id: '3d4d3dae15d54d7e8b7b3cfd93b70c2f',
          name: 'FacilityID',
          type: AssetAttribute.TypeEnum.Open
        },
        {
          id: '45aef5b6bacb4dd1b8a64699787a6297',
          name: 'FacilityLocation',
          type: AssetAttribute.TypeEnum.Point
        },
        {
          id: '05f06f598b9e471db95849f4abd8b8bd',
          name: 'FacilityName',
          type: AssetAttribute.TypeEnum.Open
        },
        {
          id: 'dc27398268754269bdc96279f9544e12',
          name: 'FacilityProvince',
          type: AssetAttribute.TypeEnum.Open
        },
        {
          id: 'd074d15e5e9d4f61bab7763ed1d93bec',
          name: 'FacilityPostalCode',
          type: AssetAttribute.TypeEnum.Open
        },
        {
          id: 'b2b801ebd8924023aa9186304282f78a',
          name: 'SubArea',
          type: AssetAttribute.TypeEnum.Set
        },
        {
          id: '003838b9a4e049ca96d6a329043b38ea',
          name: 'LocationType',
          type: AssetAttribute.TypeEnum.Set
        },
        {
          id: 'c676fe6b12d94e489596b4cb99820f64',
          name: 'BrandGroups',
          type: AssetAttribute.TypeEnum.Set
        },
        {
          id: 'd9447c5505c74194b9fecb4a17c03f30',
          name: 'FacilityState',
          type: AssetAttribute.TypeEnum.Open
        },
        {
          id: '3f2094c6e06e45c19c41ce1c691445ce',
          name: 'FacilityCountry',
          type: AssetAttribute.TypeEnum.Open
        },
        {
          id: '98877b65d3924e78b621da787b1b3a05',
          name: 'ManagedHotelGroups',
          type: AssetAttribute.TypeEnum.Open
        },
        {
          id: 'fc8e01dac8b74f13a2a7dd434959c831',
          name: 'FacilityAddress1',
          type: AssetAttribute.TypeEnum.Open
        }
      ],
      hasErrors: false,
      isValid: true
    });
  }
}
